import React from "react";
import { Modal, Button } from "react-bootstrap";

// Generic confirm-before-action modal. Same header treatment as the rest of
// the app (AppointmentPicker / CasePickerPanel). Drive it from useConfirm so
// the consumer can await a boolean answer in a handler instead of juggling
// state and callbacks.
export default function ConfirmModal({
  show,
  title = "Confirm",
  message = "",
  confirmLabel = "Continue",
  cancelLabel = "Cancel",
  confirmVariant = "primary",
  onConfirm,
  onCancel,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header
        closeButton
        style={{ background: "#CFE2FF" }}
        className="rounded-0 text-primary d-flex align-items-center"
      >
        <Modal.Title as="h6" className="m-0">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ whiteSpace: "pre-line" }}>{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
